import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import Table from "../../../table";
import styles from "./styles";
import NoData from "../../../nodata";
import { Link } from "react-router-dom";

import { ModalHeader, ModalContents, ModalFooter } from "../../../common/modal";

class SearchTarget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editSaving: false,
      errors: {},
      selected: {},
      error: null
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClose() {
    this.props.close();
  }

  handleSubmit() {
    let selectedTargetDetail = this.props.targetList.find(
      f => f.id == Object.getOwnPropertyNames(this.state.selected)[0]
    );
    this.props.selectTarget(selectedTargetDetail);
  }

  selectedRows = rows => {
    this.setState({
      selected: rows
    });
  };
  render() {
    const { languages, modal, translate, classes, selectedTest, isTestEdit } = this.props;
    let { targetList } = this.props;
    const { customer, errors, error, selected } = this.state;

    const _selected = { ...selected };
    const columns = [];

    columns.push({
      id: "url",
      accessor: d => d["url"],
      Cell: o => (
        <div style={{ textAlign: "left", paddingLeft: 40 }}>{o.value}</div>
      )
    });
    columns.push({
      id: "id",
      accessor: d => d["id"],
      show: false
    });
    targetList = targetList.filter(item => item.url != null);
    return (
      <Modal open={modal} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {translate("sub_set_search_heading", { name: selectedTest })}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon> clear </Icon>
              </Button>
            </ModalHeader>
            {targetList && targetList.length > 0 ? (
              <div>
                <ModalContents className={classes.rootModal}>
                  <Table
                    translate={translate}
                    data={targetList}
                    columns={columns}
                    allowSelectOne
                    selectedRows={this.selectedRows}
                    selected={_selected}
                    defaultPageSize={targetList.length}
                    showPagination={false}
                    style={{
                      border: "none",
                      position: "relative"
                    }}
                  />
                </ModalContents>
                <ModalFooter>
                  <Button
                    raised
                    color="primary"
                    className={classes.submit}
                    onClick={this.handleSubmit}
                    type="submit"
                  >
                    {translate("sub_set_ping_select_target")}
                  </Button>
                </ModalFooter>
              </div>
            ) : (
                !isTestEdit ? (<div className={classes.noDataBox}>
                    <Typography type="subheading" color="inherit">
                      {translate("sub_test_empty_target_search_t1", {
                        type: selectedTest
                      })}
                    </Typography>
                    <Typography type="subheading" color="inherit">
                      {translate("sub_test_empty_target_search_t2")}
                      <Link to={`/subtestsetting/${selectedTest.toLowerCase()}`}>
                        {translate("sub_test_empty_target_search_t3", {
                          name: selectedTest
                        })}
                      </Link>
                    </Typography>
                </div>)
                :
            (<div className={classes.noDataBox}>
                    <Typography type="subheading" color="inherit">
                      {translate("edit_sub_test_empty_target_search_t1")}
                    </Typography>
                    <Typography type="subheading" color="inherit">
                      {translate("edit_sub_test_empty_target_search_t2")}
                    </Typography>
                </div>)
            )}
          </Paper>
        </div>
      </Modal>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { editSaving } = this.state;
    const { customer } = nextProps;
    if (!editSaving) {
      if (customer) {
        this.setState({
          customer: { ...customer }
        });
        return;
      }
    }
    this.setState({
      customer: {
        ...this.state.customer,
        logo: customer ? customer.logo : null,
        logopath: customer ? customer.logopath : null
      }
    });
  }
}

export default withStyles(styles)(SearchTarget);
